<template>
	<div v-if="shouldShow" class="invalid-feedback" :class="{ 'd-block': forceShow }">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'BFormInvalidFeedback',
	props: {
		state: {
			type: Boolean,
			default: null
		},
		forceShow: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		shouldShow() {
			return this.forceShow || this.state === false
		}
	}
}
</script>
